import { drainHermesSseBuffer } from './hermesSseEvents.js'

export async function readHermesStream(response, { onEvent } = {}) {
  const reader = response.body?.getReader()
  if (!reader) return JSON.parse(await response.text())

  const decoder = new TextDecoder()
  const acc = { result: null, error: '', run: runFromHeaders(response) }
  let buffer = ''

  try {
    while (true) {
      const { value, done } = await reader.read()
      if (done) break
      buffer += decoder.decode(value, { stream: true })
      buffer = drainHermesSseBuffer(acc, buffer, false, onEvent)
    }
  } catch (err) {
    if (acc.run?.runId && acc.run?.statusUrl) {
      return { __chatRunPoll: acc.run }
    }
    const message = err instanceof Error ? err.message : 'Error in input stream'
    return { __chatRunError: message }
  }

  drainHermesSseBuffer(acc, buffer, true, onEvent)
  if (acc.result) return acc.result
  if (acc.error) return { __chatRunError: acc.error }
  if (acc.run?.runId && acc.run?.statusUrl) return { __chatRunPoll: acc.run }
  return { __chatRunError: 'Hermes stream ended without a final result.' }
}

function runFromHeaders(response) {
  const runId = response.headers.get('x-hermes-run-id')
  if (!runId) return null
  return {
    runId,
    status: 'running',
    statusUrl: response.headers.get('x-hermes-status-url') || `/api/hermes/runs/${runId}`,
  }
}
